module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('span', {
    staticClass: "badge",
    class: [{
      up: !!_vm.up
    }, _vm.setImp]
  }, [_vm._v(_vm._s(_vm.showValue))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-2881c5b0!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/comp/badges.vue
// module id = 298
// module chunks = 2